import React, { useState, useEffect } from "react";
import { Box, Grid, Typography, Card, TextField, Button, Checkbox, FormControlLabel, MenuItem, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";

const OlympiadItemDeliverModal = ({ closePopup, modalData }) => {
    const [deliveryStatus, setDeliveryStatus] = useState("shipped");


    const submitFinalTracking = async () => {

        const isSuccess = window.confirm("Are you sure you want to deliver to RM this shipment ?");

        if (!isSuccess) return;

        try {
            const res = await window.Platform.database.updateRegStatusForDeliveredForWeb({ regId: modalData.regId });

            if (res.status) {
                window.NotificationUtils.showSuccess(res?.message || "Successfully Done");
                closePopup();
            } else {
                window.NotificationUtils.showError(res?.message || "Something went wrong");
            }
        } catch (err) {
            console.error(err);
            window.NotificationUtils.showError("API Failed");
        }
    };

    return (
        <Box p={3}>
            <IconButton
                onClick={closePopup}
                sx={{
                    position: "absolute",
                    right: 8,
                    top: 8
                }}
            >
                <CloseIcon />
            </IconButton>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", fontSize: "20px", fontWeight: "600", marginBottom: "10px" }}>
                Update Delivery Status ({modalData?.rno_id})
            </div>
            <Box p={3}>

                <Grid container spacing={2}>
                    <Grid item xs={12} md={12}>
                        <TextField
                            label="Delivery Status"
                            select
                            fullWidth
                            size="small"
                            label="Delivery Status"
                            value={deliveryStatus}
                            onChange={(e) => { setDeliveryStatus(e.target.value) }}
                        >
                            <MenuItem value="shipped">Shipped</MenuItem>
                            <MenuItem value="delivered to rm">Delivered To RM</MenuItem>
                        </TextField>
                    </Grid>

                </Grid>
                <Box mt={3} display="flex" gap={2}>
                    <Button
                        disabled={deliveryStatus == "shipped"}
                        fullWidth
                        variant="contained"
                        color="success"
                        onClick={() => { submitFinalTracking() }}
                    >
                        Submit
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

export default OlympiadItemDeliverModal;